const STC_ID = '0A024AC9';
const STRATUS_ID = '0A024ADM';

export {
    STC_ID,
    STRATUS_ID
};